import useLanguageChange from "../../hooks/useLanguageChange";
import { LogFirebase } from "../../services/firestore";
import { indexedDBService } from "./indexedDBService";

const RetryOfflineFailedImagesToastModal = ({ closeToast, data }) => {
    const localisedValues = useLanguageChange();

    const handleRetry = () => {
        LogFirebase("OfflineMode", "RetryOfflineFailedImagesToastModal", {
            store_image_count: data?.storedImages,
            message: "User clicked retry on the retry toast modal",
        });
        closeToast(true);
        data.handleActionFunction();
    };

    const handleCloseRetryToast = async () => {
        const images = await indexedDBService.getAllImages();
        LogFirebase("OfflineMode", "RetryOfflineFailedImagesToastModal", {
            image_count: images?.length,
            message: "User closed the retry toast modal",
        });
        closeToast(true);
        await indexedDBService.deleteAllImages();
    };

    return (
        <div className='toast-notification-message-text'>
            <div className='toast-notification-msg-header'>
                <h4 className='toast-notification-msg-title'>{localisedValues?.upload_failed}</h4>
                <button type='button' className='toast-notification-close-btn' onClick={handleCloseRetryToast}>
                    <span className='btn-icon icon-close-light'></span>
                </button>
            </div>
            <div className='toast-notification-msg-body'>
                <p>{localisedValues?.some_images_failed_to_upload_due_to_a_network_error}</p>
                <p>
                    <strong>{localisedValues?.note_colon}</strong>{" "}
                    {localisedValues?.closing_this_modal_will_discard_all_the_images_you_have_selected_during_offline_mode}
                </p>
            </div>
            <div className='toast-notification-footer'>
                <div className='button-inline more-space button-inline-tb-space d-flex align-items-center justify-content-end'>
                    <div className='button'>
                        <button className='btn default-btn-link' onClick={handleCloseRetryToast}>
                            {localisedValues?.close}
                        </button>
                    </div>
                    <div className='button'>
                        <button className='btn default-btn-primary' onClick={handleRetry}>
                            {localisedValues?.retry}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RetryOfflineFailedImagesToastModal;
